module.exports = __webpack_public_path__ + "img/spain-cerebrovascular-disease-female.038bd18a.png";